module.exports = __webpack_public_path__ + "static/img/S5.7eb8d720.png";